import querystring from 'query-string';

export function getUtmQueryString(search, trackField) {
    const {
        utm_source = '',
        utm_medium = '',
        utm_campaign = '',
        utm_term = '',
        utm_content = ''
    } = { ...trackField, ...qsParseJoinArray(search) };
    return { utm_source, utm_medium, utm_campaign, utm_term, utm_content };
}

function qsParseJoinArray(search) {
    return Object.entries(querystring.parse(search)).reduce((newObj, [key, val]) => {
        if (Array.isArray(val)) {
            newObj[key] = val.join(',');
        } else {
            newObj[key] = val;
        }
        return newObj;
    }, {});
}

export function getSubdomainIndex(url) {
    try {
        // Extract the hostname from the URL
        const hostname = new URL(url).hostname;

        // Split the hostname into parts
        const parts = hostname.split('.');

        // Calculate the subdomain index according to Meta's specification
        // Subtracting 2 aligns with Meta's counting system
        return parts.length - 2;
    } catch (error) {
        console.error('Invalid URL:', error);
        return null; // Return null if the URL is invalid
    }
}
